import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isSessionActive } from '../../apiClient';
import ApplicationsTab from './ApplicationsTab';
import UpdateFirmwareTab from './UpdateFirmwareTab';
import LogsTab from './LogsTab';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './dashboard.css';

const TABS = [
  { id: 'applications', label: 'Applications', icon: 'fa fa-cubes' },
  { id: 'update', label: 'Update Firmware', icon: 'fa fa-cloud-upload-alt' },
  { id: 'logs', label: 'Logs', icon: 'fa fa-terminal' }
];

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [tab, setTab] = useState(() => {
    const qt = searchParams.get('tab');
    return TABS.find(t => t.id === qt) ? qt : 'applications';
  });

  useEffect(() => {
    if (!isSessionActive()) {
      navigate('/', { replace: true });
    }
  }, [navigate, location.pathname]);

  const handleLogout = useCallback(() => {
    try { window.sessionStorage.removeItem('isAuthenticated'); } catch (_) {}
    navigate('/', { replace: true });
  }, [navigate]);

  const switchTab = useCallback((id) => {
    setTab(id);
    const next = new URLSearchParams(searchParams);
    next.set('tab', id);
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <div className="dashboard-root">
      <div className="dashboard-topbar">
        <div className="dashboard-title">
          <i className="fa fa-microchip" aria-hidden="true"></i>
          Firmware OTA Dashboard
        </div>
        <div className="dashboard-user-block">
          <span className="dashboard-user-label">
            <i className="fa fa-user-circle" aria-hidden="true"></i> admin
          </span>
          <button className="btn-logout" onClick={handleLogout} type="button">
            <i className="fa fa-sign-out-alt" aria-hidden="true" style={{ marginRight: 6 }}></i>
            Logout
          </button>
        </div>
      </div>

      <div className="dashboard-tabs-bar" role="tablist">
        {TABS.map(t => (
          <div
            key={t.id}
            role="tab"
            aria-selected={tab === t.id}
            className={`dashboard-tab ${tab === t.id ? 'active' : ''}`}
            onClick={() => switchTab(t.id)}
          >
            <i className={t.icon} style={{ marginRight: 8 }} aria-hidden="true"></i>
            {t.label}
          </div>
        ))}
      </div>

      <div className="dashboard-content">
        {tab === 'applications' && <ApplicationsTab onGoUpload={() => switchTab('update')} />}
        {tab === 'update' && (
          <UpdateFirmwareTab onSuccessRefresh={() => switchTab('applications')} />
        )}
        {tab === 'logs' && <LogsTab />}
      </div>

      <ToastContainer position="top-right" theme="dark" />
    </div>
  );
};

export default Dashboard;
